import $ from 'jquery';
import 'slick-carousel';

function initAmenitiesSlider() {
	let slides = $('#ucgAmenitiesList .amenity-categories');

	if ($(window).width() < 960) {
		if (slides.length && slides.find('.wp-block-group').length) {
			slides.not('.slick-initialized').slick({
				arrows: false,
				autoplay: true,
				autoplaySpeed: 7000,
				dots: true,
				infinite: true,
				pauseOnHover: false,
				pauseonFocus: false,
				speed: 1000,
			});
		}
	} else {
		if (slides.hasClass('slick-initialized')) {
			slides.slick('unslick');
		}
	}
}

$(window).on('load resize', function () {
	initAmenitiesSlider();
});
